import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import UUID from 'vue-uuid'
import { Toast } from 'vant'
import { Dialog } from 'vant'
import { JSEncrypt } from 'jsencrypt' // RSA加密插件
import '@vant/touch-emulator'
import vFilters from './utils/filter'

import 'lib-flexible/flexible' // 设置根基准px

Vue.use(Toast)
Vue.use(Dialog)
Vue.use(UUID)

for (const key in vFilters) {
  Vue.filter(key, vFilters[key])
}

Vue.prototype.$RSA = password => {
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCfvVSl7UOWWF9tNCQS5aN68vSoTaa5aerzRdt+DOT7UaAL4VUE/nsmbJgIgI8pMhpR5ZqY9Ygm9Bfr5ei6ckirIxZWw3RcNkiJ65KqaHPQJaE+WVCT/KhBPldw+loxliwEmnWSB11YlFG6ALHHaYF2HdhRacvl/JjttoT8eMpQZwIDAQAB')
  return encrypt.encrypt(password)
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
